import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useAndReportExperimentTreatment } from '@ms/yammer-hooks/dist/experiments';

type UseIsSearchNavPhase1Enabled = () => boolean;
export const useIsSearchNavPhase1Enabled: UseIsSearchNavPhase1Enabled = () => {
  const treatment = useAndReportExperimentTreatment(Experiment.NavPhase1) as string;

  return treatment === 'pillars_header_menu_search';
};
